module.exports = __webpack_public_path__ + "img/play_video.abac48a7.png";